import { styled } from "@mui/material/styles";

export const BulletedList = styled("ul")({
    listStyle: "none",
    "& li": {
        position: "relative",
        "&:before": {
            content: '"•"',
            fontSize: "2rem",
            position: "absolute",
            left: "-1.5rem",
            lineHeight: "1.5rem",
            top: 0,
        },
    },
});
